import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setPopUp } from 'actions/environment';
import cn from 'classnames';
import styles from './InaccuracyReport.scss';
import { withTranslation } from 'react-i18next';
import iconFeedback from 'assets/images/icons/icon-feedback.svg';
import InaccuracyReportDialog from '../InaccuracyReportDialog';
import { gaEvent, trackGA } from '../../../services/ga';

class InaccuracyReport extends Component {
  handleClick = () => {
    const { building, profile, objectType } = this.props;

    trackGA(
      gaEvent.buildingRightMenuButtonsClick({
        eventLabel: 'soobshchit_o_netochnosti',
        eventContent: building.title,
        productType: objectType,
        productName: building.title,
        productID: building.id,
        user_id: profile.id,
      })
    );

    this.props.setPopUp(
      <InaccuracyReportDialog building={building} profile={profile} objectType={objectType} />,
      {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
      }
    );
  };

  render() {
    const { className, t, withText } = this.props;
    return (
      <div className={cn(styles.InaccuracyReport, className)}>
        <button
          className={styles.ButtonCreateInaccuracyReport}
          onClick={this.handleClick}
          data-tip={t('components.building.main.inaccuracyReport.add')}
          data-for="global"
        >
          {withText ? (
            <div className={styles.ButtonContent}>
              <img src={iconFeedback} alt="" className={styles.ButtonIcon} />
              <span className={styles.ButtonText}>
                {t('components.building.main.inaccuracyReport.add')}
              </span>
            </div>
          ) : (
            <img src={iconFeedback} alt="feedback" />
          )}
        </button>
      </div>
    );
  }
}

export default withTranslation()(
  connect((state) => state.profile, {
    setPopUp,
  })(InaccuracyReport)
);



// WEBPACK FOOTER //
// ./src/components/Building/InaccuracyReport/InaccuracyReport.js